<template>
  <div>
    <el-dialog
      title="模板库"
      :visible.sync="dialogTemplateVisible"
      :close-on-click-modal="false"
      :append-to-body="false"
      @close="close"
    >
      <el-tabs
        v-model="tabName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="系统模板" name="system">
          <div class="template-content" v-loading="loading">
            <div class="left"  v-if="systemList.length">
              <ul>
                <li
                  class="left-item"
                  v-for="item in systemList"
                  :key="item.id"
                  :class="sysTemplateDetail.id === item.id ? 'item-active' : ''"
                  @click="clickItem(item, 1)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="right"  v-if="systemList.length">
              <img
                class="template-img"
                :src="sysTemplateDetail.picUrl"
                alt=""
              />
              <div class="template-intr">
                简介：{{ sysTemplateDetail.description }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自定义模板" name="custom">
          <div class="template-content" v-loading="loading">
            <div class="left" v-if="customList.length">
              <ul>
                <li
                  v-for="item in customList"
                  :key="item.id"
                  class="left-item"
                  :class="
                    custTemplateDetail.id === item.id ? 'item-active' : ''
                  "
                  @click="clickItem(item, 0)"
                >
                  {{ item.name }}
                  <img
                    v-if="custTemplateDetail.id === item.id"
                    class="template-del"
                    @click.stop="delAgain(item)"
                    :src="require('@/assets/images/template-del.png')"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="right" v-if="customList.length">
              <img
                class="template-img"
                :src="custTemplateDetail.picUrl"
                alt=""
              />
              <div class="template-intr">
                添加时间：{{ custTemplateDetail.createTime }}
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="useCurTempalte">使用此模板</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllTemplateList,
  delCustomizeT,
  addSmartMarketing,
} from "@/api/intelligentMarket/index";

export default {
  /**
   * 组件参数
   * @param {String} dialogTemplateVisible 必填:是 [模板弹窗显示隐藏]
   * @param {String} systemList            必填:否 [系统模板列表]
   * @param {String} customList            必填:否 [自定义模板列表]
   */
  props: {
    dialogTemplateVisible: {
      type: Boolean,
      default: false,
    },
    isGoto: {
      type: Boolean,
      default: false
    },
    activityName: {
      type: String,
      default: ""
    },
    smartMarketingId: {
      type: Number,
      default: 1
    },
    nodeDataArray: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      loading: false,
      tabName: "system",
      templateId: "",
      templateType: 1,
      templateId: 0,
      templateDetail: {},
      sysTemplateDetail: {},
      custTemplateDetail: {},
      systemList: [],
      customList: [],
    };
  },

  created() {
    console.log('活动名称------>', this.activityName)
    this.getTemplateList();
  },

  methods: {
    // tabs点击时,切换模板类型
    handleClick(tab) {
      this.tabName = tab.name;
      if (this.tabName === "system") {
        this.templateType = 1;
        this.templateDetail = this.sysTemplateDetail;
      } else {
        this.templateType = 2;
        this.templateDetail = this.custTemplateDetail;
      }
      this.templateId = this.templateDetail.id;
    },

    // 获取模板列表
    async getTemplateList() {
      this.loading = true
      const sysData = await getAllTemplateList({ templateType: 1 });
      const custData = await getAllTemplateList({ templateType: 2 });
      this.loading = false
      this.systemList = sysData.data;
      this.customList = custData.data;
      if (this.systemList.length) {
        // 初始化模板渲染时的数据
        if (this.tabName === "system") {
          this.templateId = this.systemList[0].id;
          this.templateDetail = this.systemList[0];
        }
        this.sysTemplateDetail = this.systemList[0];
      }
      if (this.customList.length) {
        // 初始化模板渲染时的数据
        if (this.tabName === "custom") {
          this.templateId = this.customList[0].id;
          this.templateDetail = this.customList[0];
        }
        this.custTemplateDetail = this.customList[0];
      }
    },

    close() {
      this.$emit("close");
    },

    // 左边模板被点击时
    clickItem(item, type) {
      this.templateId = item.id;
      this.templateDetail = item;
      if (type) {
        this.sysTemplateDetail = item;
      } else {
        this.custTemplateDetail = item;
      }
    },

    // 使用当前模板
    async useCurTempalte() {
      let activityName = this.activityName
      // 判断使用模板是从列表新建，还是在编辑页面使用
      if(this.isGoto) {
        let date = new Date().toLocaleString().replace(/\//g,"-")
        activityName = "智能营销 " + date.slice(5)
        let params = {
          activityName,
          templateId: this.templateId,
          templateType: this.templateType,
        };
        const data = await addSmartMarketing(params);
        if (data.code === 1) {
          this.$emit("close");
          let routeUrl = this.$router.resolve({
            name: "miDetal",
            query: { id: data.data, actName: activityName, type: "Edit", statusNum: 0},
          });
          window.open(routeUrl.href, "_blank");
        }
      } else {
        /**
         * 判断画布是否存在节点
         * 如果存在需要提示
        */
        if(this.nodeDataArray.length) {
          this.$confirm('当前画布已存在节点，使用此模版将会覆盖，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.toCreateNewTemplate()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });          
          });
          return
        } else {
          this.toCreateNewTemplate()
        }
      }
    },

    // 在当前活动使用新的模板，而不是创建一个新的活动
    async toCreateNewTemplate() {
      let params = {
        id: this.smartMarketingId,
        templateId: this.templateId,
        templateType: this.templateType,
      };
      const data = await addSmartMarketing(params);
      if(data.code) {
        this.$emit("close")
        this.$emit("setinit")
        this.$message.success("使用成功")
        // let routeUrl = this.$router.resolve({
        //   name: "miDetal",
        //   query: { id: this.smartMarketingId, actName: this.activityName, type: "Edit", statusNum: 0},
        // });
        // window.open(routeUrl.href, "_self")
      }
    },

    // 二次确认删除
    delAgain(item) {
      this.$confirm('是否删除此模版?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delCustomTemplate(item)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },

    // 删除自定义模板
    async delCustomTemplate(item) {
      try {
        const data = await delCustomizeT(item.id);
        if (data.code === 1) {
          this.getTemplateList();
          this.$message.success("删除成功");
        } else {
          this.$message.error(data.data.message);
        }
      } catch (error) {
        console.log(error);
      }

    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 950px !important;
  height: 636px;
  min-width: 950px !important;
  min-height: 636px;
}

.template-content {
  display: flex;
  width: 902px;
  min-width: 902px;
  height: 380px;
  min-height: 380px;
  margin-top: 9px;
  .left {
    width: 424px;
    height: 380px;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    margin-right: 24px;
    ul {
      margin: 0;
      padding: 0;
      height: 100%;
      overflow: auto;
      padding: 16px 21px 0px 16px;
      &::-webkit-scrollbar {
          width:7px;
          height:10px;
      }
      &::-webkit-scrollbar-track {
          border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius:10px;
      }
      &::-webkit-scrollbar-thumb:hover {
          background: #ddd;
      }

      .left-item {
        position: relative;
        width: 100%;
        height: 24px;
        line-height: 24px;
        margin-bottom: 11px;
        list-style: none;
        cursor: pointer;
        z-index: 1;
        border-radius: 2px;
        padding-left: 8px;
        .template-del {
          position: absolute;
          right: 24px;
          width: 14px;
          height: 14px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
        }
      }

      .item-active {
        background-color: rgba(49,89,255,0.1);
        color: #7f85e9;
      }
    }
  }

  .right {
    width: 500px;
    height: 380px;

    .template-img {
      width: 100%;
      height: 314px;
    }

    .template-intr {
      font-size: 12px;
      color: #999999;
      padding: 16px 12px;
      height: 66px;
      background-color: #F3F4F4;
      border-radius: 0px 0px 8px 8px;
    }
  }
}

/deep/.el-dialog__footer {
  padding: 4px 20px 28px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.dialog-footer {
  margin-top: 14px;
  padding-top: 0;
}

/deep/.el-dialog__body {
  padding: 12px 0px 28px 24px !important;
  color: #333333;
  font-size: 14px;
  word-break: break-all;
}

/deep/.el-tabs__header{
  padding-right: 24px;
}
</style>